import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Check } from 'lucide-react';

const CTA = () => {
  const { t } = useTranslation('landing');
  return (
    <section className="py-24 bg-gradient-to-b from-[#0f0f12] to-[#0a0a0b]">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
          {t('cta.headline')}
        </h2>
        <p className="text-xl text-gray-400 mb-8">
          {t('cta.subtitle')}
        </p>

        {/* Trust badges */}
        <div className="flex flex-wrap justify-center gap-6 mb-8">
          <div className="flex items-center gap-2 text-sm text-gray-400">
            <div className="w-5 h-5 rounded-full bg-green-500/20 flex items-center justify-center">
              <Check className="w-3 h-3 text-green-400" />
            </div>
            <span>{t('cta.trust_free')}</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-gray-400">
            <div className="w-5 h-5 rounded-full bg-green-500/20 flex items-center justify-center">
              <Check className="w-3 h-3 text-green-400" />
            </div>
            <span>{t('cta.trust_no_card')}</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-gray-400">
            <div className="w-5 h-5 rounded-full bg-green-500/20 flex items-center justify-center">
              <Check className="w-3 h-3 text-green-400" />
            </div>
            <span>{t('cta.trust_cancel')}</span>
          </div>
        </div>

        <Link
          to="/register"
          className="inline-flex items-center gap-2 bg-amber-500 text-black px-8 py-4 rounded-xl text-lg font-semibold hover:bg-amber-400 transition-all duration-300 shadow-lg shadow-amber-500/20"
        >
          {t('cta.button')}
          <span>→</span>
        </Link>
      </div>
    </section>
  );
};

export default CTA;
